import { VDirective, VServices } from '@libTs/vue-base';
import { DirectiveBinding } from 'vue/types/options';

export const uploaded: VDirective = [
  'uploaded',
  {
    bind( el: HTMLElement, binding: DirectiveBinding ) {

      $( document ).ready( function () {
        $( 'input[type=file]' ).click( function () {
          $( this ).val( '' );
        } );

        $( 'input[type=file]' ).change( function () {
          $( '.upload-button' ).addClass( 'data-loaded' );
          $( '#success-ico' ).replaceWith('<i class="fas fa-check upload-icon"></i>');

          const fileName = $( 'input[type=file]' )[0].files[0].name;

          $( '#upload-button-message' ).replaceWith(fileName + ' hochgeladen');
        } );
      } );


    }
  },
];
